import math from './source/math';
import chinese from './source/chinese';
import nosmsmath from './source/nosms-math';
import nosmschinese from './source/nosms-chinese';
import overseaFan from './source/oversea-fan'
import newPay from "./source/newPay";
import school from './source/school-channel'

export default [
    math,
    chinese,
    nosmsmath,
    nosmschinese,
    ...school,
    ...newPay,
    ...overseaFan
]
